import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container relative" }
const _hoisted_2 = {
  class: "grid grid-cols-1 mt-6 relative",
  "data-aos": "fade-up",
  "data-aos-duration": "500",
  "data-aos-delay": "500"
}
const _hoisted_3 = { class: "lg:me-8 order-2 md:order-1" }
const _hoisted_4 = {
  id: "accordion-flush",
  "data-accordion": "collapse",
  "data-active-classes": "text-gray-500",
  "data-inactive-classes": "text-gray-500"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["data-accordion-target", "aria-controls"]
const _hoisted_8 = ["id", "aria-labelledby"]
const _hoisted_9 = ["innerHTML"]

import {onMounted, ref} from 'vue';
import {initAccordions} from "flowbite";

import Fees from "@/components/fees.vue";
import Training from "@/components/training.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'membership',
  setup(__props) {

onMounted(() => {
	initAccordions();
})

const faqData = ref([
	{
		id: 1,
		title: 'Anmeldung',
		desc: 'Wenn du nach einem Schnupperkurs oder Probetraining Mitglied werden möchtest, dann fülle unseren Aufnahmeantrag aus und bringe den Antrag mit zum Training oder schicke den Antrag per Mail an unseren Kassenwart. Den Aufnahmeantrag findest du unter Downloads.'
	},
	{
		id: 2,
		title: 'Jahresbeiträge',
      desc: ''
	},
   {
      id: 3,
      title: 'Trainingszeiten',
      desc: ''
   },
	{
		id: 4,
		title: 'Schnupperkurse',
		desc: 'Für am Verein Interessierte bieten wir Schnupperkurse an. Das Mindestalter beträgt zehn Jahre. Falls du eine körperliche Beeinträchtigung haben solltest, gib dies gerne an, damit sich unsere Trainer optimal darauf einstellen können. Der Schnupperkurs findet nur nach Anmeldung statt für einen Beitrag von 20 € pro Person.' +
				'<br /><br />' +
				'Das Material stellen wir dir zu dem Termin zur Verfügung. Du benötigst im Sommer festes Schuhwerk, da unser Gelände richtig in der Natur liegt, und nicht zu weite Oberbekleidung. Außerdem solltest du entweder eine Regenjacke oder ein Insektenmittel dabeihaben. Wir schießen auch bei Regen, und wenn es trocken ist, haben wir am Flusslauf natürlich eine ganze Menge Insekten herumfliegen.' +
				'<br /><br />' +
				'Bei der ersten Einweisung werden dir die wichtigsten Grundtechniken gezeigt und du kannst auch schon die ersten Schüsse abgeben.' +
				'<br /><br />' +
				'<b>Wichtig:</b> Unsere Schnupperkurse sind für Leute gedacht, die uns und unseren Sport wirklich kennenlernen wollen – nicht als Programm für Geburtstage, Junggesellenabschiede, Firmenfeiern oder ähnliche Events. Dafür fehlt uns schlicht die Kapazität, wir bitten um euer Verständnis.' +
				'<br /><br />' +
				'Anmelden kannst du dich über unser Kontaktformular oder direkt bei unserem Sportwart.'
	},
	{
		id: 5,
		title: 'Gastschützen',
		desc: 'Gastschützen dürfen das Gelände nur in Begleitung eines Vereinsmitgliedes nutzen. Das Vereinsmitglied muß die Gastschützen rechtzeitig beim Vorstand anmelden. Das Scheibengeld beträgt für Erwachsene 10 € und für Kinder 5 €.'
	},
	{
		id: 6,
		title: 'Du möchtest deine Mitgliedschaft beenden?',
		desc: 'Deine Kündigung kann formlos über das Kontaktformular oder per E-Mail an den Kassenwart erfolgen. Die Kündigungsfrist beträgt drei Monate zum Kalenderjahresende. Der Austritt ist mit Ablauf des Kalenderjahres rechtskräftig.'
	}
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", {
      class: "title grid grid-cols-1 pb-6 text-center",
      "data-aos": "fade-down",
      "data-aos-duration": "500"
    }, [
      _createElementVNode("h1", { class: "font-semibold text-4xl mb-3" }, "Unser Verein"),
      _createElementVNode("div", { class: "border" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-6 text-2xl md:leading-normal leading-normal font-bold" }, "Du möchtest Mitglied bei uns werden?", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-base my-4" }, "Für Interessierte ohne Erfahrung bieten wir Schnupperkurse an. Nähere Infos findest du unter dem Menüpunkt Schnupperkurse.", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-base my-4" }, "Erfahrene Bogenschützen mit eigener Ausrüstung können gerne nach vorhergehender Anmeldung zu den offiziellen Trainingszeiten zu einem Probetraining vorbeischauen.", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-base my-4" }, "Neue Vereinsmitglieder dürfen das Vereinsgelände bis zur Erlangung der Platzreife durch einen Trainer nur zu den offiziellen Trainingszeiten oder in Begleitung eines erfahrenen Schützen nutzen!", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqData.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              value: index,
              key: index
            }, [
              _createElementVNode("h4", {
                id: 'accordion-flush-heading'+item.id,
                class: "text-xl"
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "flex text-left items-center justify-between w-full px-2 py-5 font-medium rtl:text-right border-b border-gray-200 dark:border-gray-700 gap-3",
                  "data-accordion-target": '#accordion-flush-body-'+item.id,
                  "aria-expanded": "false",
                  "aria-controls": 'accordion-flush-body-'+item.id
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("svg", {
                    "data-accordion-icon": "",
                    class: "w-3 h-3 rotate-180 shrink-0",
                    "aria-hidden": "true",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 10 6"
                  }, [
                    _createElementVNode("path", {
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 5 5 1 1 5"
                    })
                  ], -1))
                ], 8, _hoisted_7)
              ], 8, _hoisted_6),
              _createElementVNode("div", {
                id: 'accordion-flush-body-'+item.id,
                class: "hidden text-base p-5",
                "aria-labelledby": 'accordion-flush-heading-'+item.id
              }, [
                (item.id === 2)
                  ? (_openBlock(), _createBlock(Fees, { key: 0 }))
                  : _createCommentVNode("", true),
                (item.id === 3)
                  ? (_openBlock(), _createBlock(Training, { key: 1 }))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  class: "text-slate-400 dark:text-gray-400",
                  innerHTML: item.desc
                }, null, 8, _hoisted_9)
              ], 8, _hoisted_8)
            ], 8, _hoisted_5))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})